{
  "name": "cv-convergente-web",
  "version": "CVC_WEB_R26_Q2_1_0",
  "type": "module",
  "packageManager": "pnpm@10.28.1",
  "scripts": {
    "ng": "ng",
    "config": "node scripts/generate-env.cjs",
    "config:matrix": "node scripts/gen-config-matrix.cjs",
    "postinstall": "node scripts/generate-env.cjs",
    "prestart": "node scripts/generate-env.cjs --country cr --env dev",
    "start": "ng serve --configuration=development",
    "start:cr": "node scripts/generate-env.cjs --country cr --env dev && ng serve --configuration=development",
    "start:hn": "node scripts/generate-env.cjs --country hn --env dev && ng serve --configuration=development",
    "start:ni": "node scripts/generate-env.cjs --country ni --env dev && ng serve --configuration=development",
    "start:gt": "node scripts/generate-env.cjs --country gt --env dev && ng serve --configuration=development",
    "start:sv": "node scripts/generate-env.cjs --country sv --env dev && ng serve --configuration=development",
    "start:cr:uat": "node scripts/generate-env.cjs --country cr --env uat && ng serve --configuration=uat",
    "start:hn:uat": "node scripts/generate-env.cjs --country hn --env uat && ng serve --configuration=uat",
    "start:ni:uat": "node scripts/generate-env.cjs --country ni --env uat && ng serve --configuration=uat",
    "start:gt:uat": "node scripts/generate-env.cjs --country gt --env uat && ng serve --configuration=uat",
    "start:sv:uat": "node scripts/generate-env.cjs --country sv --env uat && ng serve --configuration=uat",
    "start:uat": "node scripts/generate-env.cjs --country cr --env uat && ng serve --configuration=uat",
    "start:prod": "node scripts/generate-env.cjs --country cr --env prod && ng serve --configuration=production",
    "build": "node scripts/generate-env.cjs --country cr --env prod && ng build --configuration=production",
    "build:dev": "node scripts/generate-env.cjs --country cr --env dev && ng build --configuration=development",
    "build:uat": "node scripts/generate-env.cjs --country cr --env uat && ng build --configuration=uat",
    "build:prod": "node scripts/generate-env.cjs --country cr --env prod && ng build --configuration=production",
    "watch": "node scripts/generate-env.cjs --country cr --env dev && ng build --watch --configuration development",
    "test": "tsx --test-reporter=spec node_modules/jasmine/bin/jasmine.js --config=jasmine.json",
    "lint:atlas": "node scripts/atlas-lint.cjs",
    "lint": "eslint \"src/**/*.{ts,html}\"",
    "lint:fix": "eslint \"src/**/*.{ts,html}\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "22.0.0-next.4",
    "@angular/compiler": "22.0.0-next.4",
    "@angular/core": "22.0.0-next.4",
    "@angular/forms": "22.0.0-next.4",
    "@angular/platform-browser": "22.0.0-next.4",
    "@angular/router": "22.0.0-next.4",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^14.0.2"
  },
  "overrides": {
    "vite": ">=7.3.2",
    "picomatch": ">=4.0.4",
    "hono": ">=4.12.16",
    "ip-address": ">=10.1.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^19.0.2",
    "@angular-eslint/eslint-plugin": "^19.0.2",
    "@angular-eslint/eslint-plugin-template": "^19.0.2",
    "@angular-eslint/schematics": "^19.0.2",
    "@angular-eslint/template-parser": "^19.0.2",
    "@angular/build": "22.0.0-next.2",
    "@angular/cli": "22.0.0-next.2",
    "@angular/compiler-cli": "22.0.0-next.4",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.19.1",
    "@typescript-eslint/parser": "^8.19.1",
    "eslint": "^9.18.0",
    "jasmine": "^5.5.0",
    "prettier": "^3.8.1",
    "tsx": "^4.19.2",
    "typescript": "~5.9.2"
  },
  "pnpm": {
    "onlyBuiltDependencies": [
      "@parcel/watcher",
      "esbuild",
      "lmdb",
      "msgpackr-extract"
    ]
  }
}
